export default "/_next/static/dfe14a12828891692fad7879f3606d00.png";